import { render, staticRenderFns } from "./alpha-slider.vue?vue&type=template&id=3efcd691&"
import script from "./alpha-slider.vue?vue&type=script&lang=js&"
export * from "./alpha-slider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports